import Layout from "../../Internal/Layout.vue";
import Course from "./components/Course.vue";
import Index from "./Index.vue";
import Combo from "./components/Combo.vue";

const CoursesRoutes = {
  component: Layout,
  children: [
    {
      path: "",
      name: "Courses",
      component: Index,
      meta: {
        requiresMaster: true,
        requiresAdmin: true,
        requiresMarketing: true,
        requiresAuth: true,
        requiresManagerial: true,
        requiresFinancial: true,
        requiresImprimaxtec: true,
      },
    },
    {
      path: "/cursos-cadastrar",
      name: "Course",
      component: Course,
      meta: {
        requiresMaster: true,
        requiresAdmin: true,
        requiresMarketing: true,
        requiresAuth: true,
        requiresManagerial: true,
        requiresFinancial: true,
        requiresImprimaxtec: true,
      },
    },
    {
      path: "/combos-cadastrar",
      name: "Combo",
      component: Combo,
      meta: {
        requiresMaster: true,
        requiresAdmin: true,
        requiresMarketing: true,
        requiresAuth: true,
        requiresManagerial: true,
        requiresFinancial: true,
        requiresImprimaxtec: true,
      },
    },
  ],
};

export default CoursesRoutes;
